import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { isInternalLogActor } from "@/common/utils/logs/isInternalLogActor";

interface LogChangeActionLinkProps {
  requestId?: string;
  linkTo?: string;
  actorHints?: (string | null | undefined)[];
  domainHints?: (string | null | undefined)[];
}

const LogChangeActionLink = ({ requestId, linkTo, actorHints = [], domainHints = [] }: LogChangeActionLinkProps) => {
  const hasLink = Boolean(requestId && linkTo);

  if (!hasLink || !linkTo) return null;

  const hasInternalHint =
    actorHints.some((hint) => isInternalLogActor(hint)) ||
    domainHints.some((domain) => isInternalLogActor(domain));

  if (hasInternalHint) {
    return null;
  }

  return (
    <Link to={linkTo}>
      <ArrowBigRight />
    </Link>
  );
};

export default LogChangeActionLink;
